<mat-nav-list class="p-0" [dragula]="bagName" [dragulaModel]='lessons'>
  <ng-container *ngFor="let lesson of lessons">
  <div>
    <app-lesson-list-item [lesson]="lesson" [lecture]="lecture"></app-lesson-list-item>
    <mat-divider></mat-divider>
  </div>
  </ng-container>
</mat-nav-list>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson-list/lesson-list.component.html